var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6FEFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_88_13356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_88_13356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5H21V20.5H25V19.5H21V15.5H20V19.5H16V20.5H20V24.5ZM20.5034 29C19.2588 29 18.0887 28.7638 16.9931 28.2915C15.8975 27.8192 14.9444 27.1782 14.134 26.3685C13.3235 25.5588 12.6819 24.6066 12.2091 23.512C11.7364 22.4174 11.5 21.2479 11.5 20.0034C11.5 18.7588 11.7362 17.5887 12.2085 16.4931C12.6808 15.3975 13.3218 14.4444 14.1315 13.634C14.9412 12.8235 15.8934 12.1819 16.988 11.7092C18.0826 11.2364 19.2521 11 20.4966 11C21.7412 11 22.9113 11.2362 24.0069 11.7085C25.1025 12.1808 26.0556 12.8218 26.866 13.6315C27.6765 14.4412 28.3181 15.3934 28.7908 16.488C29.2636 17.5826 29.5 18.7521 29.5 19.9966C29.5 21.2412 29.2638 22.4113 28.7915 23.5069C28.3192 24.6025 27.6782 25.5556 26.8685 26.366C26.0588 27.1765 25.1066 27.8181 24.012 28.2909C22.9174 28.7636 21.7479 29 20.5034 29ZM20.5 28C22.7333 28 24.625 27.225 26.175 25.675C27.725 24.125 28.5 22.2333 28.5 20C28.5 17.7667 27.725 15.875 26.175 14.325C24.625 12.775 22.7333 12 20.5 12C18.2667 12 16.375 12.775 14.825 14.325C13.275 15.875 12.5 17.7667 12.5 20C12.5 22.2333 13.275 24.125 14.825 25.675C16.375 27.225 18.2667 28 20.5 28Z",
    fill: "#15B79E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragFilesIcon);
export default __webpack_public_path__ + "static/media/drag-files-icon.35de829fac92453b88d1dbdc11c3224e.svg";
export { ForwardRef as ReactComponent };